module.exports = __webpack_public_path__ + "static/media/029.c4fed4d0.jpg";